
import {
    DetailsListLayoutMode, IColumn, IContextualMenuItem, Selection, SelectionMode
} from '@fluentui/react';
import { RootState } from 'app/store';
import CollapsiblePanel from "components/controls/CustomPanel";
import { addUpdateNonStandards } from 'global/Reducer/dataSlice';
import { ArrayToLookupByPredicateWithMap, copyPropertiesOnly, formatDate, parseDate } from 'global/Utility/TSFunctions';
import {
    bcbs_config_section as IXrmTypes_bcbs_config_section
} from 'model/CRM';
import {
    IBenefit as FAM_IBenefit,
    IGroupConfigurationData as FAM_IGroupConfigurationData,
    INonStandard as FAM_INonStandard,
    IPlan as FAM_IPlan
} from 'model/FlexibleAttributeModel';
import { useEffect, useMemo, useRef, useState } from 'react';
import { connect, ConnectedProps, useDispatch } from 'react-redux';
import { calcFieldName, createNonStandard, createNonStandardColumns, createNonStandardGlobalColumns, EViewType, friendlyValue } from "../../global/Application";
import NonStandardEditor from './NonStandardEditor';
import NonStandardWizard from './NonStandardWizard';

import { RouterParams } from 'App';
import CustomDetailList from 'components/controls/CustomDetailList';
import { DefaultGridConfig } from 'components/controls/CustomDetailList/CustomDetailList';
import { ICustomDetailListConfiguration } from 'components/controls/CustomDetailList/ICustomDetailListConfiguration';
import { IGridItem } from 'components/controls/CustomDetailList/IGridItem';
import { useApplication } from 'global/Application/Context';
import { updateCustomDetailListConfiguration } from 'global/Reducer/statusSlice';

import { useHistory, useParams } from 'react-router-dom';
import NonStandardTemplateWizard from './NonStandardTemplateWizard';
import { ConfirmationDialog } from '../../components/controls/ConfirmationDialog';
import { EControlType } from '../../components/ControlWrapper';
import { IExtendedColumn } from '../../model/IExtendedColumn';
import { WithRecycle } from 'global/Application/dataActions';
import { $att_$non_standard_$bcbs_benefitdefinition_id, $att_$non_standard_$bcbs_doesthisbenefitpayaccoridngtotherelatedbe_id, $att_$non_standard_$bcbs_effectivedate_id } from "model/ConfigAttributeConstants";

interface IProps extends TComponentConnectedProps {
    groupConfiguration?: FAM_IGroupConfigurationData;
    benefit?: FAM_IBenefit;
    section?: IXrmTypes_bcbs_config_section;
    disabled?: boolean;
    nonStandards?: FAM_INonStandard[];
}

interface INonstandardToRowScope {
    groupConfig: FAM_IGroupConfigurationData;
    plan?: FAM_IPlan;
    benefit?: FAM_IBenefit;
    nonStandard: FAM_INonStandard;
}


const gridStyles = {
    root: {
        marginBottom: '1.45em',
        marginTop: '6px',
    },
    headerWrapper: {
        selectors: {
            '.ms-DetailsHeader': {
                paddingTop: '0px',
            },
        }
    }
};

type TNonstandardGridItem = IGridItem<FAM_INonStandard>;

const NonStandardGlobalGridView = (props: IProps) => {

    const dispatch = useDispatch();
    const application = useApplication();
    const history = useHistory();
    const [nonStandard, setNonStandard] = useState<FAM_INonStandard | null>(null);

    const [nonStandardEditorIsMounted, setNonStandardEditorIsMounted] = useState(false);
    const [nonStandardEditorIsOpen, _setNonStandardEditorIsOpen] = useState(false);
    const setNonStandardEditorIsOpen: React.Dispatch<React.SetStateAction<boolean>> = (value) => {
        if (!nonStandardEditorIsMounted)
            setNonStandardEditorIsMounted(true);
        _setNonStandardEditorIsOpen(value);
    }

    const [selectionCount, setSelectionCount] = useState(0);
    const [selectedItems, setSelectedItems] = useState<FAM_INonStandard[] | null>(null);

    const [nonStandardWizardIsMounted, setNonStandardWizardIsMounted] = useState(false);
    const [nonStandardWizardIsOpen, _setNonStandardWizardIsOpen] = useState(false);
    const setNonStandardWizardIsOpen: React.Dispatch<React.SetStateAction<boolean>> = (value) => {
        if (!nonStandardWizardIsMounted)
            setNonStandardWizardIsMounted(true);
        _setNonStandardWizardIsOpen(value);
    }

    const [nonStandardTemplateWizardIsMounted, setNonStandardTemplateWizardIsMounted] = useState(false);
    const [nonStandardTemplateWizardIsOpen, _setNonStandardTemplateWizardIsOpen] = useState(false);
    const setNonStandardTemplateWizardIsOpen: React.Dispatch<React.SetStateAction<boolean>> = (value) => {
        if (!nonStandardTemplateWizardIsMounted)
            setNonStandardTemplateWizardIsMounted(true);
        _setNonStandardTemplateWizardIsOpen(value);
    }

    const [alertIsMounted, setAlertIsMounted] = useState(false);
    const [alertIsOpen, _setAlertIsOpen] = useState(false);
    const setAlertIsOpen: React.Dispatch<React.SetStateAction<boolean>> = (value) => {
        if (!alertIsMounted)
            setAlertIsMounted(true);
        _setAlertIsOpen(value);
    }
    //CREATE A NEW ON OPEN METHOD OR ON ADD AND ADD THAT VIEW TO THE WIZARD THEN BACK HERE INVOKE THE TEMPLATE WIZARD DUHHHHHH

    const params = useParams<RouterParams>()

    const categoryGroupConfiguration = props.state.data.config.cache.map_bcbs_config_category_named['Group Configuration'];

    let disabled = props.disabled;

    const disableAddingNonstandardByChangeType =
        (props.benefit && !application.ChangeTypePermissions.benefit.add_nonstandard) ||
        (props.groupConfiguration && !application.ChangeTypePermissions.canAddGroupConfigurationNonstandard);

    // if not disabled and for benefit but can not add nonstandard to benefit
    if (!disabled && disableAddingNonstandardByChangeType)
        disabled = true;

    // if not disabled and for group configuration but can not add nonstandard to group configuration
    if (!disabled && disableAddingNonstandardByChangeType)
        disabled = true;

    const storageId = `nonstandard.grid(GLOBALGRID)`;

    const scopeGridConfig = () => {
        const u = props.state.status.gridConfigs[storageId];
        if (u)
            return u;

        const t = DefaultGridConfig();
        t.sort = [{ column: { key: 'nonStandardName' }, isSortedDescending: false }];

        return t;
    }

    // useEffect(() => {
    //         if (props.isOpen) {
                
    //             debugger;
    //             // Use EntityHelpers to get entity context
    //             const context = getEntityContext({
    //                 data: props.state.data,
    //                 benefit: props.benefit,
    //                 groupConfiguration: props.groupConfiguration,
    //                 accountsReceivable: props.accountsReceivable,
    //                 feesAndPremium: props.feesAndPremium,
    //                 sectionForNSConfigId: props.sectionForNS?._bcbs_config_categoryid_value
    //             });
    //             setEntityContext(context);
    
                
    //         }
    //     }, []);

    const [gridConfig, setGridConfig] = useState<ICustomDetailListConfiguration>(scopeGridConfig());
    const gridConfigRef = useRef(gridConfig);

    // check if it has changed since mounting
    if (gridConfig !== gridConfigRef.current) {

        gridConfigRef.current = gridConfig;

        // snapshot for bind back
        dispatch(updateCustomDetailListConfiguration({ id: storageId, gridConfig: structuredClone(gridConfig) }));
    }

    const onColumnClick = (event: React.MouseEvent<HTMLElement, MouseEvent>, column: IColumn) => {
        setGridConfig(t => {

            const gridConfig: ICustomDetailListConfiguration = { ...t };

            gridConfig.sort = [{
                column: { key: column.key },
                isSortedDescending: !t?.sort?.[0]?.isSortedDescending ?? false,
            }];


            return gridConfig;
        });
    };



    let scopeNonStandards: FAM_INonStandard[] = [];


    props.state.data.json.benefits.forEach(eachBenefit => {

        //const benefitPlans = props.state.data.json.plans.filter(eachPlan => eachPlan.benefitRefs.find(q => q.id === eachBenefit.id));

        //// benefit part of a plan, we need to duplicate
        //if (benefitPlans?.length > 0)
        //    benefitPlans.forEach(eachPlan => {
        //        eachBenefit.nonStandards.forEach(eachNS => {
        //            scopeNonStandards.push(eachNS);
        //        });
        //    });
        //else
        //    eachBenefit.nonStandards.forEach(eachNS => {
        //        scopeNonStandards.push(eachNS);
        //    });
        eachBenefit.nonStandards.forEach(eachNS => {
                scopeNonStandards.push(eachNS);
            });

    });

    props.state.data.json.nonStandards.forEach(eachNS => {
        scopeNonStandards.push(eachNS);
    });

    props.state.data.json.claimsARs.forEach(eachAR => {

        eachAR.nonStandards.forEach(eachNS => {
                scopeNonStandards.push(eachNS);
            });

    });

    props.state.data.json.feesAndPremiums.forEach(eachFP => {

        eachFP.nonStandards.forEach(eachNS => {
                scopeNonStandards.push(eachNS);
            });

    });


    //useEffect(() => {
    //    if (history.location.search === '?navigation=pending')
    //        if (params.nonStandardId)
    //            setTimeout(() => {
    //                const nonstandard = scopeNonStandards.find(t => t.id === params.nonStandardId);
    //                if (nonstandard) {
    //                    const section = props.state.data.config.cache.map_bcbs_config_section[nonstandard?.sectionRef?.id!];
    //                    const tab = props.state.data.config.cache.map_bcbs_config_tab[section._bcbs_config_tabid_value!];
    //                    if (section.bcbs_config_sectionid === props.section.bcbs_config_sectionid) {
    //                        onSelect([nonstandard]);

    //                        if (!params.field2ndId && !params.tab2ndId && !params.section2ndId)
    //                            history.push({ pathname: history.location.pathname, search: '?navigation=complete' });
    //                    }
    //                }
    //            }, 200);
    //}, []);

    const columns = useMemo(() => {
        let columns = createNonStandardGlobalColumns(
                props.state.data.config,
                {
                    //nonStandard: ns,
                    config: props.state.data.config,
                    tierNames: null
                },
                gridConfig,
                onColumnClick
            );

        
        return columns;

    }, [gridConfig.filter, gridConfig.sort]);

    const [items, itemsPaged] = useMemo(() => {

        const items: TNonstandardGridItem[] = [];


        const gridConfigMappedColumns = {
            filterColumns: gridConfig.filter.map(q => columns?.find(w => w.key === q.column.key)),
            sortColumns: gridConfig.sort.map(q => columns?.find(w => w.key === q.column.key)),
        }

        scopeNonStandards.forEach((eNonStandard, index) => {

            // skip deactivated records/only show deactivated records if permitted at group config properties level (xnor)
            if (eNonStandard.deactivated !== props.state.data.json.showInActives?.value)
                return;

            //get category that the NS is on, maybe benefit definition? maybe which template it is associated to? can do this through .find
            const section = props.state.data.config.cache.map_bcbs_config_section[eNonStandard.sectionRef!.id];
            const categoryType = props.state.data.config.cache.map_bcbs_config_category[section!._bcbs_config_categoryid_value!];
            let benefitName = "";
            let benefitId = "";
            props.state.data.json.benefits.forEach(benefit => {
                const foundNS = benefit.nonStandards.find(ns => ns.id === eNonStandard.id);
                if (foundNS) {
                    benefitId = benefit.id
                    benefitName = benefit.name;
                }
            })
            props.state.data.json.claimsARs.forEach(benefit => {
                const foundNS = benefit.nonStandards.find(ns => ns.id === eNonStandard.id);
                if (foundNS) {
                    benefitId = benefit.id
                    benefitName = benefit.name;
                }
            })
            props.state.data.json.feesAndPremiums.forEach(benefit => {
                const foundNS = benefit.nonStandards.find(ns => ns.id === eNonStandard.id);
                if (foundNS) {
                    benefitId = benefit.id
                    benefitName = benefit.name;
                }
            })
            const categoryName = categoryType.bcbs_name === "Group Configuration" ? "Group Configuration" : benefitName;
            const tab = props.state.data.config.cache.map_bcbs_config_tab[section!._bcbs_config_tabid_value!];

            const nsFields = ArrayToLookupByPredicateWithMap(eNonStandard!.fields, t => t.configRef.id, t => {
                const attribute = props.state.data.config.cache.map_bcbs_config_attribute[t.configRef.id];
                const masterAttribute = props.state.data.config.cache.map_bcbs_config_masterattribute[attribute._bcbs_config_masterattributeid_value!];
                const controlType = masterAttribute.bcbs_attributetypecode as EControlType;
                return {
                    field: t,
                    attribute,

                    masterAttribute,
                    controlType,
                }
            });
            if (Object.keys(nsFields).length === 0) //if no fields present in config - skip this non-standard
                return;
            const nonStandardEffectiveDate = nsFields[$att_$non_standard_$bcbs_effectivedate_id];
            const nonStandardBenefitDefintion = nsFields[$att_$non_standard_$bcbs_benefitdefinition_id];
            const nonStandardPayAccordingToBenefit = nsFields[$att_$non_standard_$bcbs_doesthisbenefitpayaccoridngtotherelatedbe_id];
            let nonStandardEffectiveDateValue = "";
            let nonStandardDefinitionValue = "";
            let nonStandardPayAccordingToBenefitValue = "";
            if (nonStandardEffectiveDate.field.values[0].value !== null) {
                nonStandardEffectiveDateValue = formatDate(parseDate(friendlyValue(nonStandardEffectiveDate.controlType, nonStandardEffectiveDate.field.values[0].value), 'local:yyyy-MM-dd'), 'en-US-ET');
            }
            if (nonStandardBenefitDefintion.field.values[0].value !== null) {
                nonStandardDefinitionValue = friendlyValue(nonStandardBenefitDefintion.controlType, nonStandardBenefitDefintion.field.values[0].value);
            }
            if (nonStandardPayAccordingToBenefit) {
                if(nonStandardPayAccordingToBenefit.field.values[0].value)
                {
                    if(nonStandardPayAccordingToBenefit.field.values[0].value !== null)
                    {
                        nonStandardPayAccordingToBenefitValue = friendlyValue(nonStandardPayAccordingToBenefit.controlType, nonStandardPayAccordingToBenefit.field.values[0].value);
                    }
                }
            }
            
            const item: TNonstandardGridItem = {
                key: eNonStandard.id,
                name: eNonStandard.name,
                partOfTemplate: eNonStandard.partOfTemplate,
                categoryType: categoryType.bcbs_name,
                categoryName: categoryName,
                tab: tab.bcbs_name,
                benefit: benefitId,
                section: section.bcbs_name,
                benefitDefition: nonStandardDefinitionValue,
                effectiveDate: nonStandardEffectiveDateValue,
                payToBenefit: nonStandardPayAccordingToBenefitValue,
                _index: index,
                data: eNonStandard
            };

            eNonStandard.fields.forEach(eaField => {
                const configAttributeId = eaField.configRef.id;
                // lets always get the first one
                // verified with William there will never be a Tier/PCP/Specialist mode for these.

                eaField.values.forEach(eachFieldValue => {

                    item[`${configAttributeId}-${eachFieldValue?.tierRef?.id ?? ''}`] = eachFieldValue.value;
                });
            });

            // Filtering :
            let include = true;
            if (gridConfig && gridConfig.filter && gridConfig.filter.length > 0) {
                gridConfig.filter.forEach((filter, ix) => {
                    const column = gridConfigMappedColumns.filterColumns[ix];
                    if (column) {
                        const predicate = column.filterPredicate;
                        if (predicate)
                            include = include && predicate(item, filter.value, column);
                    }
                });
            }

            if (include)
                items.push(item);
        });


        if (gridConfig && gridConfig.sort && gridConfig.sort.length > 0)
            items.sort((a, b) => {

                let ret = 0;

                gridConfig.sort?.forEach((sort, ix) => {
                    const column = gridConfigMappedColumns.sortColumns[ix];

                    // TODO why was this needed?
                    if (!column)
                        return;

                    const predicate = column.sortPredicate;
                    const isSortedDescending = sort.isSortedDescending ?? false;

                    if (predicate)
                        ret = ret || isSortedDescending
                            ? predicate(a, b, undefined, column) * -1
                            : predicate(a, b, undefined, column);
                });

                return ret;

            });


        const itemsPaged = items.slice((gridConfig.page - 1) * gridConfig.pageSize, gridConfig.page * gridConfig.pageSize);

        return [items, itemsPaged];
        // return items;
    },
        [
            props.groupConfiguration?.nonStandards,
            props.benefit?.nonStandards,
            props.nonStandards,
            props.state?.data?.json?.showInActives?.value,
            gridConfig.filter,
            gridConfig.sort,
            gridConfig.page,
        ]
    );

    const selection = useRef(new Selection({
        onSelectionChanged: () => {

            const selectionCount = selection.current.getSelectedCount();
            setSelectionCount(selectionCount);

        },
        selectionMode: SelectionMode.multiple,
    }))

    const onSelect = (selectedItems: FAM_INonStandard[]) => {
        if (!props.section)
            throw new Error('section has not been identified.');

        if (selectedItems && selectedItems.length === 1) {
            const _t = selectedItems[0];

            setNonStandard(structuredClone(_t));

            //setNonStandardEditorIsOpen(true);

        } else if (selectedItems && selectedItems.length > 1) {

            setSelectedItems(selectedItems);

            const _t = createNonStandard(props.state.data, {
                section: props.section,
                benefit: props.benefit,
                groupConfiguration: props.groupConfiguration,
                // feesAndPremium: props.feesAndPremium,
                // accountsReceivable: props.accountsReceivable
            });
            _t.id = 'bulk';

            setNonStandard(_t);
            //setNonStandardEditorIsOpen(true);
        }
    }

    const onRenderGrid = () => {
        return <CustomDetailList
            items={items}
            itemsPaged={itemsPaged}
            columns={columns}
            quickSearchColumnKey={'nonStandardName'}
            selectionMode={SelectionMode.multiple}
            styles={gridStyles}
            layoutMode={DetailsListLayoutMode.fixedColumns}
            selection={selection.current}
            onShouldVirtualize={() => false}
            getKey={(item) => { return item.key }}
            onItemInvoked={(item: TNonstandardGridItem, index, event) => {
                console.log(item)
                //navigate to non Standard

                let path = `/records/blueRelationship/${props.state.data.snapshot._bcbs_groupid_value}`;

                path += `/groupConfiguration/${props.state.data.snapshot.bcbs_groupconfigurationsnapshotid}`;

                if (item.benefit)
                    path += `/benefit/${item.benefit}`;

                var section = props.state.data.config.cache.map_bcbs_config_section[item!.data!.sectionRef!.id];
                var tab = props.state.data.config.cache.map_bcbs_config_tab[section._bcbs_config_tabid_value!];
                if (tab)
                    path += `/tab/${tab.bcbs_config_tabid}`;

                if (section)
                    path += `/section/${section.bcbs_config_sectionid}`;

                path += `/nonStandard/${item.data!.id}`;


                dispatch(
                    WithRecycle(() => {
                        history?.push({ pathname: path, search: '?navigation=pending' });
                    }, 100)
                );

            
            }}
            gridConfig={[gridConfig, setGridConfig]}
        />;
    }

    // const onRenderEditor = () => {
    //     if (!nonStandardEditorIsMounted)
    //         return <></>;

    //     const costshareCategory = props.benefit ?? categoryGroupConfiguration;

    //     return <NonStandardEditor
    //         isOpen={nonStandardEditorIsOpen}
    //         onDismiss={() => { setNonStandardEditorIsOpen(false); }}
    //         defaultValue={nonStandard ?? null}
    //         costshareCategory={costshareCategory}
    //         benefit={props.benefit}
    //         disabled={disabled}
    //         onChange={(nonStandard, changeTracker) => {
    //             let dispatchNonStandards = [nonStandard];

    //             if (nonStandard.id === 'bulk') {

    //                 if (!selectedItems)
    //                     return;

    //                 const selectedItemsCloned = structuredClone(selectedItems);

    //                 selectedItemsCloned.forEach(eClone => {
    //                     eClone.fields.forEach(eCloneField => {
    //                         const matchingField = nonStandard.fields.find(q => q.configRef.id === eCloneField.configRef.id);
    //                         if (matchingField) {
    //                             eCloneField.values.forEach(eCloneFieldValue => {
    //                                 // tier refs should exactly match since they are both originated from same source tier levels
    //                                 const matchingFieldValue = matchingField.values.find(q => q.type === eCloneFieldValue.type && q.tierRef?.name === eCloneFieldValue.tierRef?.name)
    //                                 if (matchingFieldValue?.value)
    //                                     eCloneFieldValue.value = matchingFieldValue.value;
    //                             });
    //                         }
    //                     });

    //                     copyPropertiesOnly(nonStandard,
    //                         eClone,
    //                         ['deactivated', 'referenceOnly'],
    //                         false,
    //                         (key, source) => {
    //                             if (source[key] === undefined)
    //                                 return false;

    //                             return true;
    //                         }
    //                     );

    //                 });

    //                 dispatchNonStandards = selectedItemsCloned;
    //             }

    //             dispatch(
    //                 addUpdateNonStandards([
    //                     {
    //                         config: props.state.data.config,
    //                         nonStandards: dispatchNonStandards,
    //                         groupConfiguration: props.groupConfiguration,
    //                         benefit: props.benefit,
    //                         changeTracker: changeTracker
    //                     }]
    //                 )
    //             );

    //             setNonStandardEditorIsOpen(false);
    //             setSelectedItems(null);
    //         }}
    //     />

    // }

    // function onRenderAlert(): JSX.Element {
    //     if (!alertIsMounted)
    //         return <></>;

    //     return <ConfirmationDialog
    //         onClose={() => { setAlertIsOpen(false); setAlertIsMounted(false); }}
    //         onContinue={() => { setAlertIsOpen(false); setAlertIsMounted(false); }}
    //         continueText="Continue"
    //         cancelText="Cancel"
    //     >
    //         <p>Only one Non-Standard may be selected for templating from this screen</p>
    //     </ConfirmationDialog>;
    // }

    // const onRenderTemplateWizard = () => {
    //     if (!nonStandardTemplateWizardIsMounted)
    //         return <></>;

    //     return <div>
    //         <NonStandardTemplateWizard
    //             isOpen={nonStandardTemplateWizardIsOpen}
    //             onCancel={() => setNonStandardTemplateWizardIsOpen(false)}
    //             onDismiss={() => setNonStandardTemplateWizardIsOpen(false)}
    //             benefit={props.benefit}
    //             groupConfiguration={props.groupConfiguration}
    //             nonStandard={nonStandard ?? undefined}
    //         />
    //     </div>
    // }

    const onRender = () => {
        return <div>
            <CollapsiblePanel
                title='Non-Standards'
                id={`nonStandardGlobal`}
                canCollapse={true}
                defaultCollapsed={true}
                mountWhenExpanded={true}
                storageId={`nonStandardGlobalID`}
                //items={menu}
            >
                {onRenderGrid()}
            </CollapsiblePanel>
        </div>
    }

    return onRender();
}

function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connector(NonStandardGlobalGridView);
